import React from 'react'

import { useDashboardPermissions } from '@components/utils/DashboardPermissions'
import { TableItemDate } from '@components/utils/TableItemDate'
import { InProgress, PriceString, ProfitString } from '@fourthwall/components'

import type { ThankYou } from '../../ThankYous.types'
import * as S from './ThankYouListItem.styled'

type ThankYouListItemProps = {
  thankYou: ThankYou
}

export const ThankYouListItem = ({ thankYou }: ThankYouListItemProps) => {
  const { hasPermission } = useDashboardPermissions()

  return (
    <S.Container>
      <S.Details>
        <S.Supporter>{thankYou.supporter.fullName}</S.Supporter>
        <S.Tags>
          {thankYou.tags.map((tag, index) => (
            <S.Tag key={`${tag}${index}`}>{tag}</S.Tag>
          ))}
        </S.Tags>
        {thankYou.message && <S.Message>{thankYou.message}</S.Message>}
        <S.Date>
          <TableItemDate
            date={thankYou.state === 'SENT' ? thankYou.updatedAt : thankYou.createdAt}
          />
        </S.Date>
      </S.Details>
      <S.Calculations>
        <PriceString value={thankYou.total.value} />
        {hasPermission('contributions.profit') && (
          <InProgress>
            <S.Profit>
              <ProfitString value={0.01} />
            </S.Profit>
          </InProgress>
        )}
      </S.Calculations>
    </S.Container>
  )
}
